import './index.scss'
import AnimatedLetters from '../AnimatedLetters'
import { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCss3, faGitAlt, faGithub, faHtml5, faJsSquare, faReact, faSass } from '@fortawesome/free-brands-svg-icons'
import Loader from 'react-loaders'

const About = () => {
    const [letterClass, setLetterClass] = useState('text-animate')

    setTimeout(() => {setLetterClass('text-animate-hover')}, 3000)
    
    return (
        <>
        <div className="container about-page" >
            <div className="text-zone">
                <h1>
                    <AnimatedLetters
                    letterClass={letterClass}
                    strArray={['A', 'b', 'o', 'u', 't', ' ', 'm', 'e']}
                    idx={15}
                    />
                </h1>
                <p>I am a highly skilled frontend developer with experience using modern web frameworks and tools, such as Javascript, HTML, ReactJS, CSS, and more. I have a proven track record of building fast and responsive SPAs, games, website components, and other useful programmatic tools. I am also experienced in converting Figma designs into production-ready code and have experience with backend technologies such as Node.js, SQL, and BaaS tools like Firebase.

                </p>

            </div>

            <div className='stage-cube-cont'>
                <div className='cubeSpinner'>
                    <div className='face1' >
                        <FontAwesomeIcon icon={faReact} color="#61dafb" />
                    </div>
                    <div className='face2' >
                        <FontAwesomeIcon icon={faHtml5} color="#F06529" />
                    </div>
                    <div className='face3' >
                        <FontAwesomeIcon icon={faCss3} color="#28A4D9" />
                    </div>
                    <div className='face4' >
                        <FontAwesomeIcon icon={faJsSquare} color="#EFD81D" />
                    </div>
                    <div className='face5' >
                        <FontAwesomeIcon icon={faSass} color="#D06DA1" />
                    </div>
                    <div className='face6' >
                        <FontAwesomeIcon icon={faGitAlt} color="#EC4D28" />
                    </div>

                </div>

            </div>
        </div>
        <Loader type="ball-scale-multiple" /> 

        </>
    )
}


export default About